module.exports = __webpack_public_path__ + "img/sinta.8458b12c.jpg";